import { render, staticRenderFns } from "./FollowUpContent.vue?vue&type=template&id=af7a9fee&scoped=true&"
import script from "./FollowUpContent.vue?vue&type=script&lang=js&"
export * from "./FollowUpContent.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpContent.vue?vue&type=style&index=0&id=af7a9fee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a9fee",
  null
  
)

export default component.exports